export default __webpack_public_path__ + "static/media/icon-down.7a3c76bb.svg";